import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import SalesMngCostStatsRow from './SalesMngCostStatsRow';
//----------------------------------------------------------------
const useStyles = makeStyles({
  table: {
    '& .MuiTableCell-root': {
      border: '1px solid rgba(224, 224, 224, 1)',
    },
  },
});
//----------------------------------------------------------------
const SalesMngCostStatsTable = ({ loading, data, tableRef, headerRows }) => {
  const classes = useStyles();

  return (
    <Paper sx={{ overflow: 'auto', my: 1 }}>
      <TableContainer
        sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}
      >
        <Table size="small" className={classes.table} ref={tableRef}>
          <TableHead>
            <TableRow>
              <TableCell align="center">계정과목</TableCell>
              {headerRows &&
                headerRows.map((header) => {
                  return (
                    <TableCell key={header?.id} align="center">
                      {header?.label}
                    </TableCell>
                  );
                })}
            </TableRow>
          </TableHead>
          <TableBody>
            {data === null || data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={headerRows?.length + 1} align="center">
                  데이터가 없습니다.
                </TableCell>
              </TableRow>
            ) : (
              <SalesMngCostStatsRow data={data} headers={headerRows} />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default SalesMngCostStatsTable;
